import { Flex, Input, InputGroup, InputLeftAddon } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { FormField } from '../../../../components/FormField'
import { FormModal } from '../../../../components/FormModal'
import { useAppToast } from '../../../../helpers'
import {
  IGetUrlRedirectorResponse,
  ICreateUpdateUrlRedirectorPayload,
  UrlRedirectorService
} from '../../../../services/UrlShortener/UrlRedirectorService'

interface IForm {
  from: string
  to: string
}

export function UrlRedirectorEditModal({ onClose, id }: { onClose: () => void; id: number | null }) {
  const service = new UrlRedirectorService()
  const toast = useAppToast()
  const [urlData, setUrlData] = useState<null | IGetUrlRedirectorResponse>(null)
  const [form, setForm] = useState<IForm>({} as IForm)
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (id === null) return

    loadUrlData()
    setFormErrors({})
  }, [id])

  const loadUrlData = async () => {
    if (id === null) return

    const data = await service.get(id)
    setUrlData(data)
    setForm({
      from: data.from,
      to: data.to
    })
  }

  const handleToInputChange = (value: string) => {
    // Simplesmente atualiza o valor conforme o usuário digita
    setForm({ ...form, to: value })
  }

  const handleToInputBlur = (value: string) => {
    // Quando o usuário sai do campo, adiciona https:// se necessário
    if (value && !value.match(/^https?:\/\//)) {
      setForm({ ...form, to: `https://${value}` })
    }
  }

  const handleSave = async () => {
    if (id === null) return

    setSaving(true)
    setFormErrors({})
    try {
      await service.update(id, {
        from: form.from,
        to: form.to
      } as ICreateUpdateUrlRedirectorPayload)

      toast.success('Redirecionador de URL atualizado com sucesso')

      onClose()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      if (error.response?.status === 400) setFormErrors(error.response.data.errors)
      else toast.error('Erro ao atualizar o Redirecionador de URL', error)
    } finally {
      setSaving(false)
    }
  }

  return urlData ? (
    <FormModal
      isOpen={id !== null}
      onClose={onClose}
      title="Alterar redirecionador de URL"
      onSubmit={handleSave}
      isLoading={saving}
    >
      <Flex direction="column">
        <FormField label="De" error={formErrors.from} isRequired>
          <InputGroup>
            <InputLeftAddon>https://abra.com.br</InputLeftAddon>
            <Input value={form.from} disabled={saving} onChange={(e) => setForm({ ...form, from: e.target.value })} />
          </InputGroup>
        </FormField>
        <FormField label="Para" error={formErrors.to} isRequired mt={4}>
          <Input
            value={form.to}
            disabled={saving}
            onChange={(e) => handleToInputChange(e.target.value)}
            onBlur={(e) => handleToInputBlur(e.target.value)}
            type="url"
          />
        </FormField>
      </Flex>
    </FormModal>
  ) : (
    <></>
  )
}
